import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone, Inbox } from "lucide-react";

export default function ProMiniSiteMessages() {
  const [messages, setMessages] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/pro/minisite/messages")
      .then(({ data }) => setMessages(data.messages || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const fmt = (iso) => {
    try { return new Date(iso).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" }); }
    catch { return iso; }
  };

  if (!loaded) return <p className="text-slate-400">Chargement…</p>;

  return (
    <div className="space-y-4 max-w-2xl" data-testid="pro-messages">
      <p className="text-sm text-slate-500">
        Messages reçus via le formulaire de contact de votre mini-site. Ils vous sont aussi transmis par e-mail.
      </p>
      {messages.length === 0 ? (
        <div className="bg-white rounded-2xl border border-dashed border-slate-300 p-10 text-center text-slate-400" data-testid="msg-empty">
          <Inbox size={32} className="mx-auto mb-2 opacity-50" />
          Aucun message pour l'instant.
        </div>
      ) : (
        <div className="space-y-3" data-testid="msg-list">
          {messages.map((m, i) => (
            <div key={m.id || i} className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={`msg-card-${i}`}>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className="font-semibold text-slate-900">{m.name || "Visiteur"}</span>
                <span className="text-xs text-slate-400">{fmt(m.created_at)}</span>
              </div>
              <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-0.5 text-xs text-slate-500">
                {m.email && <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1 hover:text-[#C84B31]"><Mail size={12} /> {m.email}</a>}
                {m.phone && <a href={`tel:${m.phone}`} className="inline-flex items-center gap-1 hover:text-[#C84B31]"><Phone size={12} /> {m.phone}</a>}
              </div>
              <p className="mt-2 text-sm text-slate-700 whitespace-pre-wrap">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
